// import { useRoutes } from 'react-router-dom';
import AppRoutes from 'src/routes/AppRoutes';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { UserProvider } from 'src/contexts/UserContext';

function App() {

    return (
        <ThemeProvider>
            <UserProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <CssBaseline />
                    <AppRoutes />
                </LocalizationProvider>
            </UserProvider>
        </ThemeProvider>
    );
}
export default App;
